module.exports = __webpack_public_path__ + "static/media/kaci-baum-1.a8ccaf01.jpg";